/**
 * Check if a URL is an Amazon Music URL
 */
export function isAmazonMusicUrl(url: string): boolean {
  try {
    const u = new URL(url);
    const host = u.hostname.toLowerCase();
    return host.includes('music.amazon') || 
           (host.includes('amazon.') && u.pathname.includes('/music/'));
  } catch {
    return false;
  }
}

/**
 * Extract the first Amazon Music URL from a text blob.
 * Returns the full URL if found, null otherwise.
 */
export function extractFirstAmazonMusicUrl(text: string): string | null {
  if (!text || typeof text !== 'string') return null;

  // Split by whitespace and common delimiters
  const tokens = text.split(/\s+/);
  
  for (const token of tokens) {
    const cleaned = token.trim().replace(/[.,;:!?)\]}]$/, '');
    
    if (!cleaned) continue;
    
    // Try to create URL
    let normalized = cleaned;
    if (!normalized.startsWith('http://') && !normalized.startsWith('https://')) {
      normalized = `https://${normalized}`;
    }
    
    try {
      const url = new URL(normalized);
      if (isAmazonMusicUrl(url.href)) {
        return url.href;
      }
    } catch {
      // Invalid URL, continue
    }
  }
  
  return null;
}

